// extracted by mini-css-extract-plugin
module.exports = {"layout":"promo_layout__n_Obv","image":"promo_image__MmmU9","graphic":"promo_graphic__o1KQy","actions":"promo_actions__BVSln"};